module.exports = __webpack_public_path__ + "img/daifahuoicon.df76813e.png";